// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pay-way-item{
  padding: 10px 0;
  border-bottom: 1px solid #A4A4A4
}

.pay-way-item.i-tunes img{
  padding: 0;
  margin: 0;
  border: none;
}

.pay-way-item.i-tunes b{
  padding: 5px 0;
}

.pay-way-item.credit-card-item label{

}

@media (max-width: 767px) {
  .pay-way-item button{
    margin-top: 15px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/react/components/user/payment/PayWayITunes.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf;AACF;;AAEA;EACE,UAAU;EACV,SAAS;EACT,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;;AAEA;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF","sourcesContent":[".pay-way-item{\n  padding: 10px 0;\n  border-bottom: 1px solid #A4A4A4\n}\n\n.pay-way-item.i-tunes img{\n  padding: 0;\n  margin: 0;\n  border: none;\n}\n\n.pay-way-item.i-tunes b{\n  padding: 5px 0;\n}\n\n.pay-way-item.credit-card-item label{\n\n}\n\n@media (max-width: 767px) {\n  .pay-way-item button{\n    margin-top: 15px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
